var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"action-button",on:{"click":_vm.config.action}},[(_vm.config.icon)?_c('v-icon',[_vm._v(_vm._s(_vm.config.icon))]):_vm._e(),_vm._v("\n  "+_vm._s(_vm.config.label)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }